// sagas.js
import { call, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_PRICE_AUDIT_REQUEST,
  fetchPriceAuditSuccess,
  fetchPriceAuditFailure,
} from "../actions/csvPriceAuditAction";

import { getRequest } from "api/apiCall";
import captureCustomSentryEvent from "Sentry/captureCustomSentryEvent";

const apiUrl = "/products/price-upload-audit/";

// API Request Function
function* fetchCsvPriceAuditAPI(params) {
  try {
    const paramsIncluded = `${apiUrl}?page=${params.page}&page_size=${params.page_size}`;
    const response = yield call(getRequest, paramsIncluded);
    if (response) {
      return { ...response, page: params.page, page_size: params.page_size };
    } else {
      throw new Error("Failed to fetch price audit data: " + response);
    }
  } catch (error) {
    captureCustomSentryEvent("fetchPriceAuditAPI", error);
    throw error;
  }
}

// Worker Saga
function* fetchPriceAudit(action) {
  try {
    const response = yield call(fetchCsvPriceAuditAPI, action.payload);
    yield put(fetchPriceAuditSuccess(response));
  } catch (error) {
    yield put(fetchPriceAuditFailure(error));
  }
}

// Watcher Saga
function* watchFetchCsvPriceAudit() {
  yield takeLatest(FETCH_PRICE_AUDIT_REQUEST, fetchPriceAudit);
}

export default watchFetchCsvPriceAudit;
